import React from "react";
import "@components/transactions/TransactionsBulkActions/TransactionsUpdateStatus/TransactionsUpdateToast.scss";
import {
    formatBulkScheduleAppliedLabel,
    formatBulkScheduleFailedLabel,
} from "./bulkScheduleCopy";
import { BulkScheduleNoun } from "./bulkScheduleRows";

interface Props {
    scheduleName: string;
    noun: BulkScheduleNoun;
    appliedCount: number;
    failedCount: number;
    failureReason?: string;
}

export const SchedulesBulkApplyToast: React.FC<Props> = ({
    scheduleName,
    noun,
    appliedCount,
    failedCount,
    failureReason,
}) => (
    <div className="transactions-update-toast">
        <div className="transactions-update-toast__content">
            <p className="transactions-update-toast__label">
                {formatBulkScheduleAppliedLabel({
                    noun,
                    scheduleName,
                    appliedCount,
                })}
            </p>
            {failedCount > 0 && (
                <p className="transactions-update-toast__info">
                    {formatBulkScheduleFailedLabel({ noun, failedCount })}
                    {failureReason ? `: ${failureReason}` : ""}
                </p>
            )}
        </div>
    </div>
);
